import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import OperadorasView from './OperadorasView';
import * as ROUTES from '../../../router/Routes';

const OperadorasModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.operadoras}
      routes={[ROUTES.controlEstudios]}
    >
      <OperadorasView />
    </ContainerTemplate>
  );
};

export default OperadorasModule;
